export const SET_SELECTED_ITEM = '[FILE MANAGER APP] SET SELECTED ITEM';

export function setSelectedItem(id) {
  return {
    type: SET_SELECTED_ITEM,
    payload: id
  };
}



// WEBPACK FOOTER //
// ./src/main/content/apps/file-manager/store/actions/selectedItem.actions.js